// src/router/index.js
import { useStore } from '@/stores/index'
import { nextTick } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		// ==========================================
		// 店家路由區域 (主要功能)
		// ==========================================
		{
			path: '/',
			name: 'home',
			component: () => import('@/views/HomeView.vue')
		},
		{
			path: '/rules',
			name: 'rules',
			component: () => import('@/views/Rules.vue')
		},
		{
			path: '/redeem',
			name: 'redeem',
			component: () => import('@/views/redeem.vue')
		},
		{
			path: '/select-music',
			name: 'SelectMusic',
			component: () => import('@/views/SelectMusic.vue')
		},
		{
			path: '/photo-upload',
			name: 'PhotoUpload',
			component: () => import('@/views/PhotoUpload.vue'),
			beforeEnter: () => {
				const store = useStore()
				store.setPhotoUpLoad(null)
			}
		},
		{
			path: '/city-unlock',
			name: 'CityUnlock',
			component: () => import('@/views/CityUnlock.vue')
		},
		{
			path: '/store-unlock',
			name: 'StoreUnlock',
			component: () => import('@/views/StoreUnlock.vue')
		},
		{
			path: '/result',
			name: 'result',
			component: () => import('@/views/Result.vue')
		},

		// ==========================================
		// 404 處理
		// ==========================================
		{
			path: '/:pathMatch(.*)*',
			redirect: '/'
		}
	]
})

// ==========================================
// 全域 beforeEach：記錄上一個路由
// ==========================================
router.beforeEach((_to, from, next) => {
	const store = useStore()
	if (from && from.path) {
		store.previousRoutePath = from.path // 記錄上一頁
	}
	next()
})

// 路由變化時，滾動條 .main-content 容器到顶部
router.afterEach(() => {
	nextTick(() => {
		const mainContent = document.querySelector('.main-content')
		if (mainContent) {
			mainContent.scrollTop = 0
		}
	})
})
export default router
